import React from 'react'
import PropTypes from 'prop-types'
import EducationProfileEvents from './EducationProfileEvents'

EducationProfileEvent.propTypes = {
  children: PropTypes.func.isRequired,
  eventType: PropTypes.string.isRequired
}

export default function EducationProfileEvent({ eventType, children }) {
  return <EducationProfileEvents>{render(eventType, children)}</EducationProfileEvents>
}

function render(eventType, children) {
  return events => {
    const event = events && events.find(event => event.eventType === eventType)
    return event ? children(event) : null
  }
}
